import {
  Mats,
  mergeOverrides,
  Tag,
  TagProps,
  useStyletron,
} from "@mezo-org/mezo-clay"

function MarketTag({
  children,
  overrides,
  color = "red",
}: {
  children: string
} & Omit<TagProps, "children" | "closeable" | "startEnhancer">) {
  const [, theme] = useStyletron()

  return (
    <Tag
      closeable={false}
      color={color}
      startEnhancer={Mats}
      overrides={mergeOverrides(
        {
          StartEnhancerContainer: {
            style: {
              width: theme.sizing.scale700,
            },
          },
          Text: {
            style: {
              textOverflow: "unset",
              maxWidth: "unset",
            },
          },
        },
        overrides,
      )}
    >
      {children}
    </Tag>
  )
}

export default MarketTag
